import {
	type ClientPortfolioDetailRelatedPropertyResponseDTO,
	ClientPropertyTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import { propertyCarTitle } from "web_myplann/Portfolio/Helpers/propertyCarTitle";

export const getRelatedPropertyTitle = (
	property: ClientPortfolioDetailRelatedPropertyResponseDTO,
	t: (text: string) => string,
) => {
	if (property.type === ClientPropertyTypeEnum.AutoMoto) {
		const title = propertyCarTitle(
			property.carBrand,
			property.carModel,
			property.carLicensePlate,
		);

		if (title) {
			return title;
		}

		return t(Resources.PortfolioDetail.Property.PropertyType[property.type]);
	}

	if (property.type === ClientPropertyTypeEnum.Art) {
		if (property.name) {
			return property.name;
		}

		return `${t(Resources.PortfolioDetail.Property.PropertyType[property.type])} ${property.propertyType ? `(${property.propertyType})` : ""} `;
	}

	if (
		property.type === ClientPropertyTypeEnum.House ||
		property.type === ClientPropertyTypeEnum.Flat ||
		property.type === ClientPropertyTypeEnum.Cottage ||
		property.type === ClientPropertyTypeEnum.Land
	) {
		if (property.name) {
			return property.name;
		}

		let location = "";

		const parts = [
			property.location,
			property.locationMunicipality,
			property.locationZipCode,
		].filter(Boolean);

		if (parts.length > 0) {
			location = parts.join(", ");
		}

		return `${t(Resources.PortfolioDetail.Property.PropertyType[property.type])} ${location}`;
	}

	return "";
};
